import type { ApiError } from '@/shared/api';

/**
 * Warum das Branding nicht übernommen wurde. Die Texte des Servers sind englisch („Logo must be
 * between…“), deshalb steht hier der Satz je Fall — nie der rohe Servertext.
 */
export function brandingProblem(problem: ApiError) {
  if (problem.status === 409) {
    return 'Das Branding wurde inzwischen geändert. Laden Sie den aktuellen Stand.';
  }
  if (problem.status === 403) return 'Dafür fehlt Ihnen die Berechtigung.';
  if (problem.status === 0) {
    return 'Keine Antwort vom Server – ob die Änderung angekommen ist, ist offen. Bitte prüfen Sie die Verbindung.';
  }
  if (problem.status >= 500) {
    return 'Der Server konnte das gerade nicht übernehmen. Bitte versuchen Sie es erneut.';
  }
  if (problem.title.startsWith('portal_branding_logo')) {
    return 'Das Logo wurde nicht angenommen. Bitte ein PNG oder JPEG bis 5 MB verwenden.';
  }
  if (problem.title.startsWith('portal_branding_name')) {
    return 'Der Markenname darf höchstens 120 Zeichen in einer Zeile haben.';
  }
  return 'Die Eingabe wurde vom Server nicht übernommen.';
}
